import { render, staticRenderFns } from "./LayoutUser.pug?vue&type=template&id=e8ba3680&scoped=true&lang=pug&"
import script from "./LayoutUser.vue?vue&type=script&lang=js&"
export * from "./LayoutUser.vue?vue&type=script&lang=js&"
import style0 from "./LayoutUser.scss?vue&type=style&index=0&id=e8ba3680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba3680",
  null
  
)

export default component.exports